<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <page-header />
    </parallax>
    <div id="main-panel" class="main main-raised" ref="page">
      <div class="cd-section section section-basic">
        <div class="md-layout" v-if="loaded">
          <div
            class="md-layout md-layout-item md-size-65 md-small-size-90 mx-auto"
            style="margin-bottom:0px"
          >
            <h3
              v-if="model.description.type"
              class="text-primary bold panelTypeHeader"
            >{{model.description.type}}</h3>
            <hr v-if="model.description.type" class="text-primary" />
            <panel-item
              :item="model"
              :showDescription="true"
              :bigHeader="true"
              :showDate="true"
              :showThematicPath="true"
              :showLogo="false"
            />

            <div class="md-layout md-layout-item md-size-100">
              <div class="ml-auto">
                <md-button
                  v-if="hasChatAccess"
                  @click="sharePanel"
                  class="md-round md-primary md-sm md-blue-border"
                  style="margin:0px 10px 10px 0px"
                >{{$t('Share')}}</md-button>

                <md-button
                  v-if="model.additionalContent"
                  @click.prevent="downloadAdditionalContent"
                  class="md-round md-primary md-sm md-blue-border"
                  style="margin:0px 10px 10px 0px"
                >{{$t('Additional information')}}</md-button>
                <md-button
                  v-if="model.roomId"
                  @click.prevent="showOnMap"
                  class="md-round md-primary md-sm md-blue-border"
                  style="margin:0px 10px 10px 0px"
                >{{$t('Show on map')}}</md-button>
                <md-button
                  @click.prevent="$router.go(-1)"
                  class="md-round md-primary md-sm md-blue-border"
                  style="margin:0px"
                >{{$t('Go back')}}</md-button>
              </div>
            </div>
            <div
              v-if="model.attendees.length"
              style="margin:25px 0px"
              class="md-layout md-layout-item md-size-100"
            >
              <div v-for="r in distinctRoles" :key="r" class="md-layout md-layout-item md-size-100">
                <h3 class="text-primary bold" style="margin-bottom:5px">{{$t(`attendeerole.${r}`)}}</h3>
                <hr class="text-primary" />
                <attendee-item
                  v-for="a in getAttendeesByRole(r)"
                  :key="a.attendee.id"
                  :item="a.attendee"
                  :showDetailsLink="hasAttendeesAccess"
                />
              </div>
            </div>
            <div
              v-if="model.panels.length"
              style="margin:25px 0px"
              class="md-layout md-layout-item md-size-100"
            >
              <panel-item
                v-for="p in model.panels"
                :key="p.id"
                :item="p"
                :showDetailsLink="true"
                :showDate="false"
                :showThematicPath="true"
              />
            </div>
            <div
              v-if="model.partners.length"
              style="margin:25px 0px"
              class="md-layout md-layout-item md-size-100"
            >
              <h3 class="text-primary bold" style="margin-bottom:5px">{{$t(`Partners`)}}</h3>
              <hr class="text-primary" />
              <partner-item v-for="p in model.partners" :key="p.id" :item="p" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal modal-bg" :class="{ show: selectedRoomData }">
      <modal v-if="selectedRoomData" @close="selectedRoomData = null" id="building-modal">
        <template slot="header">
          <md-button
            class="md-simple md-close md-just-icon md-round modal-default-button"
            @click="selectedRoomData = null"
          >
            <md-icon>clear</md-icon>
          </md-button>
        </template>

        <template slot="body">
          <building-details
            :id="selectedRoomData.buildingId"
            :floorId="selectedRoomData.floorId"
            :roomId="selectedRoomData.roomId"
            :readonly="true"
          />
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";
import { mapGetters, mapActions } from "vuex";
import axios from "@/util/axios";
import PanelItem from "./components/Agenda/PanelListItem.vue";
import PartnerItem from "./components/Partners/PartnerListItem.vue";
import AttendeeItem from "./components/Attendees/AttendeesListItem.vue";
import PageHeader from "./layout/PageHeader";
import { Modal } from "@/components";
import BuildingDetails from "@/pages/authenticated/BuildingDetailsPage.vue";

export default {
  components: {
    PanelItem,
    AttendeeItem,
    PartnerItem,
    PageHeader,
    Modal,
    BuildingDetails
  },
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",
  computed: {
    ...mapGetters({
      language: "language/current",
      conference: "conference/current",
      isLoggedIn: "user/isLoggedIn",
      hasAttendeesAccess: "user/hasAttendeesAccess",
      hasChatAccess: "user/hasChatAccess"
    }),
    distinctRoles: function() {
      let roles = [
        ...new Map(
          this.model.attendees.map(item => [item.role, item.role])
        ).values()
      ];

      console.log(roles);

      let order = [1, 7, 6, 4, 5, 2, 3];
      order = [2, 7, 6, 1, 5, 3, 4];
      var sorted = roles.sort((a, b) => order[a] - order[b]);

      console.log(sorted);
      return sorted;
    },
    localisation() {
      let localisation = this.model.description.building;

      if (localisation && this.model.description.room) {
        localisation += ", ";
      }

      localisation += this.model.description.room;

      return localisation;
    }
  },
  props: ["id"],
  data() {
    return {
      loaded: false,
      selectedRoomData: null,
      model: { description: {}, attendees: [], panels: [] },
      image: require("@/assets/img/conference/landing-bg-fe26.jpg") // header img
    };
  },
  methods: {
    downloadAdditionalContent() {
      window.open(this.model.additionalContent, "_blank");
    },
    async loadData() {
      let loader = this.$loading.show({ container: this.$refs.page });
      try {
        this.model = (
          await axios.get("public/panels/details", {
            params: {
              year: this.conference.year,
              type: this.conference.type,
              language: this.language.code,
              id: this.id
            }
          })
        ).data;
      } finally {
        loader.hide();
        this.loaded = true;
      }
    },
    sharePanel(){
      this.$router.push({ 
        name: "chat", 
        params: { panel: { id: this.model.id, name: this.model.description.topic }}
      });
    }, 
    getAttendeesByRole(role) {
      return this.model.attendees
        .filter(e => e.role === role)
        .sort(
          (a, b) =>
            a.attendee.description.lastName > b.attendee.description.lastName ||
            (a.attendee.description.lastName ==
              b.attendee.description.lastName &&
              a.attendee.description.firstName >
                b.attendee.description.firstName)
        );
    },
    async showOnMap() {
      if (!this.model.roomId) return;

      let loader = this.$loading.show({ container: this.$refs.page });

      try {
        let result = (
          await axios.get("public/conferences/conference/roomData", {
            params: {
              id: this.model.roomId
            }
          })
        ).data;

        this.selectedRoomData = result;
      } finally {
        loader.hide();
      }
    },
    async onLike(value) {
      let loader = this.$loading.show();
      let action = value ? "add" : "remove";
      try {
        this.model.isLiked = (
          await axios.post(`public/myprofile/agenda/favourites/${action}`, {
            id: this.model.id
          })
        ).data;
      } finally {
        loader.hide();
      }
    },
    panelIcon(value) {
      return this.$options.filters["panel-icon"](value);
    }
  },
  async mounted() {
    await this.loadData();
  },
  watch: {
    async id() {
      this.model = {};
      await this.loadData();
    },
    async language() {
      this.model = {};
      await this.loadData();
    }
  }
};
</script>


<style lang="scss" scoped>
.panelTypeHeader::first-letter {
  text-transform: uppercase;
}

// h1.info-title {
//   font-size: 5rem;
// }
// .info-title {
//   color: white !important;
// }

// .info-title > hr {
//   color: white;
// }

// .page-header .container {
//   max-width: 70% !important;
// }

// .md-button.md-just-icon {
//   height: 22px;
//   min-width: 0px;
//   width: 24px;
//   padding: 0px;
//   margin: 0px;

//   margin-bottom: 5px;
//   overflow: hidden;
//   position: relative;
// }

// .md-button .md-ripple {
//   padding: 0px !important;
//   display: inline-block;
//   justify-content: center;
//   align-items: center;

//   .md-icon {
//     padding: 0px !important;
//   }
// }
</style>
